module.exports = __webpack_public_path__ + "img/positions1.341ce31b.png";